import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment'
import { useHistory } from 'react-router-dom';
import { Context } from '../../context';
import { CLOUDINARYURL } from '../../utils/constants';
const History = ({ history }) => {
    const _history = useHistory()
    const context = useContext(Context)
    const [points, setPoints] = useState(0)
    const handleClick = (data) => {
        console.log(data)
        // return
        let temp = context.currentProblemState
        temp[data._id] = data.problemId._id
        context.setCurrentProblemState(temp)
        _history.push("/solve?id=" + data.problemId._id + "&prburl=" + data.problemId.problemUrl.slice(CLOUDINARYURL.length, data.problemId.problemUrl.length))
    }

    const calculatePoints = () => {
        let points_ = 0
        for (let i = 0; i < history.length; i++)
            points_ += history[i].points
        setPoints(points_)
    }
    useEffect(() => {
        calculatePoints()
    }, [])


    return (
        <div className="pf-history-box">
            <div className="pf-history-header">
                <p className="pf-title">Activities:</p>
                <h1 data-aos="zoom-out-up">{points}</h1>
            </div>
            {
                history.reverse().map((h, idx) => (
                    <div className="pf-history-each" onClick={() => { handleClick(h) }} key={h._id} data-aos="fade-up">
                        <span><strong>Solved: </strong>{h.problemId.title}</span>
                        <span className="pf-history-time"><strong></strong>{moment(h.time).subtract('days').calendar()}</span>
                        <span><strong>Points earned: </strong>{h.points}</span>
                    </div>
                ))
            }
        </div>
    )
}
export default History